import React, { Component } from 'react';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import TransitionedBlock from "../../HelperComponents/TransitionedBlock/TransitionedBlock";
import DialogComponent from "../../HelperComponents/DialogComponent/DialogComponent";
import CreateRefundRequestDialog from '../CreateRefundRequest/CreateRefundRequestDialog';
import SplitRefundDialogContent from "./SplitRefundDialogContent";
import SnackBar from "../../HelperComponents/SnackBar/SnackBar";
import AddIcon from '../../../assets/image/add.png';
import { getOrderByNumber } from "../../../actions/ordersActions";
import { postCreateRequest } from "../../../actions/refundRequestsActions";
import './RefundRequestsHeaderButtonsPanel.scss'

const classes = {
    root: 'default_dialog_root transactions-dialog',
    paper:'paper_custom_dialog'
};

class RefundRequestsHeaderButtonsPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeItem: { amount: 1, price: 0, id: 0, lot: 0, name: '-', producer: '-', article_number: '-' },
            comment: '',
            files: [],
            initSearch: false,
            hasResults: false,
            loadingBtn: false,
            open: false,
            splitDialogOpen: false,
            results: {data: [], query: ''},
            requestAmount: 1,
            requestSum: 0,
            searchValue: '',
            showSnackBar: false,
            snackBarAttr: {
                isVisible: false,
                message: '',
                type: '',
            }
        };
    }

    toggleDialog = () => {
        this.setState(({open}) => {
            if (open) {
                return {
                    open: !open,
                    loadingBtn: false,
                    searchValue: '',
                    initSearch: false,
                    hasResults: false,
                    splitDialogOpen: false,
                    files: [],
                    comment: '',
                    messageSnackBar: '',
                    activeItem: { amount: 1, price: 0, id: 0, lot: 0, name: '-', producer: '-', article_number: '-' },
                    results: {data: [], query: ''},
                    requestAmount: 1,
                    requestSum: 0,
                }
            }

            return {
                open: !open
            }
        });
    };

    toggleSplitDialog = () => {
        this.setState(({splitDialogOpen}) => {
            return {
                splitDialogOpen: !splitDialogOpen
            }
        })
    }

    onSplitError = (error) => {
        this.setState({
            snackBarAttr: {
                isVisible: true,
                message: error,
                type: 'error'
            }
        })
    }

    onSplitSuccess = () => {
        this.setState({
            snackBarAttr: {
                isVisible: true,
                message: 'Заявка успешно разделена',
                type: 'success'
            }
        })

        if (this.props.onSuccess) {
            this.props.onSuccess();
        }

        this.toggleSplitDialog();
       
    }

    toggleSnack = () => {
        this.setState({
            snackBarAttr: {
                isVisible: false,
                message: '',
                type: '',
            }
        });
    };

    render() {
        const { open, snackBarAttr, splitDialogOpen } = this.state;
        const { selectedRows } = this.props;

        return (
            <TransitionedBlock>
                <div className="add_button">
                    { this.props.selectedRowsLength === 0 &&
                        <Button
                            classes={{
                                root: 'add_btn'
                            }}
                            onClick={this.toggleDialog}
                        >
                            Добавить
                            <img src={ AddIcon } alt="edit icon"/>
                        </Button>
                    }
                    { this.props.selectedRowsLength === 1 &&
                        <Button
                            classes={{
                                root: 'add_btn'
                            }}
                            onClick={this.toggleSplitDialog}
                        >
                            Разделить
                            <img src={ AddIcon } alt="edit icon"/>
                        </Button>
                    }
                    { this.props.selectedRowsLength > 1 &&
                        <Button
                            classes={{
                                root: 'add_btn'
                            }}
                            onClick={() => this.props.createJoinRequest()}
                            disabled={this.props.actionLoading}
                        >
                            { this.props.actionLoading ? 'Загрузка...' : 'Объединить'}
                            <img src={ AddIcon } style={{ opacity: this.props.actionLoading ? 0.5 : 1 }} alt="edit icon"/>
                        </Button>
                    }
                </div>
                <DialogComponent
                    maxWidth="lg"
                    open={splitDialogOpen}
                    onClose={this.toggleSplitDialog}
                    classes={classes}
                    
                >
                    <SplitRefundDialogContent
                        onClose={this.toggleSplitDialog}
                        selectedRow={Object.values(selectedRows).find(item => item.checked)}
                        onError={this.onSplitError}
                        onSuccess={this.onSplitSuccess}
                    />
                </DialogComponent>
                <CreateRefundRequestDialog
                    open={open}
                    toggleDialog={this.toggleDialog}
                    createRefundRequest={this.props.createRefundRequest}
                    refetch={this.props.refetch}
                    availableTabs={this.props.availableTabs}
                />
                <SnackBar
                    open={snackBarAttr.isVisible}
                    classes={snackBarAttr.type}
                    vertical="top"
                    onClose={() => this.toggleSnack()}
                >
                    { snackBarAttr.message }
                </SnackBar>
            </TransitionedBlock>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getOrderByNumber,
        postCreateRequest,
    }, dispatch);
}

export default connect(null, mapDispatchToProps)(RefundRequestsHeaderButtonsPanel);
// export default RefundRequestsHeaderButtonsPanel;
